defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Modal',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril'
  ],
  function (m) {
    var _Modal = {
      controller: function (args) {
        var thisController = this;
        if (args) {
          Object.assign(thisController, args.controller);
        }

        thisController.onAnimationEnd = function (event) {
          var animationName = event.animationName;

          if (animationName === 'generic-overlay-panel-animation') {
            thisController.actionClassName('generic-overlay--is-shown');
          }

          if (animationName === 'generic-overlay-panel-remove-animation') {
            thisController.remove();
            thisController.isRendered(false);
            thisController.actionClassName('');
            m.redraw();
          }
        };
      },
      view: function (controller, ignoreArgs, slots) {
        if (!controller.isRendered()) {
          return null;
        }

        // View:
        return m('.generic-overlay', {
          class: `${controller.className()} ${controller.actionClassName()}`,
          onanimationend: controller.onAnimationEnd
        }, [
          m('.panel', [
            m('.generic-overlay__close-button', {
              onclick: controller.close
            }, [
              m('svg', { class: 'icon' }, [
                m('use', { href: '/Components/DanskeSpil/Domain/NumberGames/Graphics/SpriteSheets/NumberGamesGenericCommonIcons.svg#icon-x' })
              ])
            ]),
            slots()
          ])
        ]);
      }
    };

    var Modal = function () {
      var container = document.createElement('div');
      var slots = m.prop(null);
      var onCloseCallback = m.prop(null);
      this.isRendered = m.prop(false);
      this.actionClassName = m.prop('');
      this.className = m.prop('');

      this.close = function () {
        this.actionClassName('remove-overlay');
      }.bind(this);

      this.remove = function () {
        this.isRendered(false);
        container.remove();
        onCloseCallback();
      }.bind(this);

      this.onClose = function (callback) {
        onCloseCallback = callback;
      };

      // `defaultContentTemplate` can be passed to the modal component as a template
      this.defaultContentTemplate = ({ heading, subheading, body, footer }) => {
        return m('.modal-content', [
          heading ? m('.modal-heading', heading) : null,
          subheading ? m('.modal-subheading', subheading) : null,
          body ? m('.modal-body', body) : null,
          footer ? m('.modal-footer', footer) : null
        ]);
      };

      this.setContent = function (content) {
        this.isRendered(true);
        slots(content);
      }.bind(this);

      this.show = function () {
        document.body.appendChild(container);
      };

      m.mount(container, m(_Modal, { controller: this }, slots));
    };

    // Public functions:
    return Modal;
  });
